export default "__VITE_ASSET__BpOvHH4t__"